import {ISortingOption} from "../../../components/UI/SearchAndSort/SearchAndSort";
import {IUser, UserContext} from "../../../hooks/Context/UserContext";
import {useContext, useEffect} from "react";
import {useQueryApplicants} from "../../../api/admin/useQueryApplicants";
import Loading from "../../../components/UI/Loading/Loading";
import {ChicletTypes} from "../../../constants/ui/types/ChicletTypes";
import UserProfile from "../../../components/UI/Profile/UserProfile";
import ProgressChiclet from "../../../components/UI/Chiclets/ProgressChiclet/ProgressChiclet";
import DocumentRequestButton from "../AdminDocumentRequest/DocumentRequestButton/DocumentRequestButton";
import Pagination from "../../assessments/components/EmployeeTablePagination/Pagination";
import {useQueryAssignedCourses} from "../../../api/admin/useQueryAssignedCourses";
import {IProgram} from "../../../constants/types/IProgram";
import {applicantsSortingOptions} from "../../../constants/ui/sortingOptions";
import {PermissionType} from "../../../constants/types/PermissionType";
import {DropdownOption} from "../../../components/UI/SearchAndSort/DropdownWithIcon/Sorting";
import FilterIcon from "../../../assets/icons/UI/icons/filter.svg";
import ComplexSearch from "../../../components/UI/ComplexSearch/ComplexSearch";
import {useQueryAdmins} from "../../../api/admin/useQueryAdmins";
import {useMutateAssignCourse} from "../../../api/admin/useMutateAssignCourse";

const AssignedCoursesTable = ({
                                searchParam,
                                page,
                                sortingValue,
                                filterValue,
                                hideReviewComplete,
                                onPageChange,
                                navigate,
                                queryClient
                              }: {
  searchParam: string;
  page: number;
  sortingValue: ISortingOption;
  filterValue: ISortingOption[];
  hideReviewComplete: boolean;
  onPageChange: (page: number) => void;
  navigate: (path: string) => void;
  queryClient: any;
}) => {
  const [user] = useContext(UserContext);

  // cpl-admin/:user_id/:portfolio_id/:program_id/:course_code
  // `cpl-admin/${item.user_id}/${item.portfolio_id}/${item.program_id}/${item.course_code}`

  useEffect(() => {
    if (user.notification_id) {
      queryClient.invalidateQueries({
        queryKey: ["applicants"],
        exact: true,
      });
    }
  }, [user.notification_id, queryClient]);

  const {data: applicants} = useQueryAssignedCourses(
    {
      hide_completed: hideReviewComplete,
      ordering: sortingValue.value,
      search_term: searchParam,
      current_page: page,
      program_ids:
        filterValue.length > 0
          ? filterValue.map((item) => item.value)
          : [],
    }
  );
  const {data: adminsList} = useQueryAdmins();
  const {mutate: assignToAdmin} = useMutateAssignCourse();

  console.log('applicants', applicants)

  const handleAssignAdmin = (admin: any, courseId: any) => {
    assignToAdmin({
      assigned_admin_id: admin?.value?.id,
      course_recommendation_id: courseId
    });
  }

  const navigateToEvidence = (item: any) => {
    navigate(`/cpl-admin/${item.user_id}/${item.portfolio_id}/${item.program_id}/${item.course_code}`);
  }


  const getApplicantStatus = (status: string): ChicletTypes => {
    switch (status) {
      case "Not started":
        return ChicletTypes.Not_started;
      case "Review in progress":
        return ChicletTypes.In_progress;
      case "Accepted":
        return ChicletTypes.Completed;
      case "Rejected":
        return ChicletTypes.Overdue;
      default:
        return ChicletTypes.Not_started;
    }
  };

  return (
    <>
      <table className="applicants-table">
        <thead>
        <tr>
          <th scope="col">Applicant</th>
          <th scope="col">Application date</th>
          <th scope="col">Program and Course</th>
          {user.permission_groups?.includes(PermissionType.cpl_super_admin)
            ? <th scope="col">Assignee</th>
            : null
          }
          <th scope="col">Assigned date</th>
          <th scope="col">Review status</th>
        </tr>
        </thead>
        <tbody>
        {applicants?.data?.course_recs?.map((item: any) => (
          <tr
            key={item.user_id}
            className={item.highlight ? 'highlight-row' : ''}
          >
            <td
              onClick={() => navigateToEvidence(item)}
              style={{minWidth: 200}}
            >
              <UserProfile
                name={{
                  first_name: item.applicant_name.split(' ')[0],
                  last_name: item.applicant_name.split(' ')[1],
                }}
                size="small"
                showText
              />
            </td>
            <td onClick={() => navigateToEvidence(item)}>
              <div className="applicants-table-created-at">
                {item.created_at}
                {/*<br/>({item.created_ago_str.toLowerCase()})*/}
                (Created 10 days ago)
              </div>
            </td>
            <td onClick={() => navigateToEvidence(item)}>
              {item.program_name} & {item.course_tile}
            </td>
            {user.permission_groups?.includes(PermissionType.cpl_super_admin)
              ? <td className={'applicants-table-assign-to'}>
                <ComplexSearch
                  dropdown={
                    {
                      options: adminsList
                        ? [
                          {
                            label: "Assign to me",
                            value: {
                              first_name: "Assign to me",
                              last_name: "",
                              id: user.id,
                            },
                          },
                          ...adminsList.map((item: IUser) => ({
                            label: `${item?.first_name} ${item?.last_name}`,
                            value: item,
                          })),
                          {
                            label: "No assignee",
                            value: {
                              first_name: "No assignee",
                              last_name: "",
                              id: "",
                            },
                          },
                        ]
                        : [],
                      value: {
                        label: item.assigned_admin_user_id
                          ? item.assigned_admin_name
                          : "N/A",
                        value: item.assigned_admin_name,
                      },
                      onChange: (newActive: DropdownOption) => handleAssignAdmin(newActive, item.course_recommendation_id),
                      icon: FilterIcon,
                    }
                  }
                />
              </td>
              : null
            }
            <td onClick={() => navigateToEvidence(item)}>
              <div className="applicants-table-created-at">
                {item.created_at}
                {/*<br/>({item.created_ago_str.toLowerCase()})*/}
                (Created 10 days ago)
              </div>
            </td>
            <td onClick={() => navigateToEvidence(item)}>
              <ProgressChiclet
                type={getApplicantStatus(item.status)}
                text={item.status}
              />
            </td>
          </tr>
        ))}
        </tbody>
      </table>
      {Number(applicants?.data.total_pages) > 1 && (
        <Pagination
          total={Number(applicants?.data.total_pages)}
          currentPage={page}
          onPageChange={(newPage) => {
            queryClient.removeQueries({
              queryKey: ["applicants"],
              exact: true
            });
            onPageChange(newPage);
            window.scroll(0, 0);
          }}
        />
      )}
    </>
  );
};

export default AssignedCoursesTable;